<template lang="pug">
table.table.table-striped.table-hover.content-list
  thead
    tr
      th(v-if="showCol('color')")
      th(v-if="showCol('checkbox') && !currentUserStore.currentUser.role_is_limited")
        CheckBox(v-model="checked")
      th(v-if="showCol('id')")
        SortLink(v-model="sort" column="id" text="ID")
      th(v-if="showCol('pub_date')")
        SortLink(v-model="sort" column="pub_date" text="Pub date")
      th(v-if="showCol('slug')")
        SortLink(v-model="sort" column="slug" text="Slug")
      th(v-if="showCol('name')")
        SortLink(v-model="sort" column="headline" text="Headline")
      th(v-if="showCol('subsites')")
        | Subsites
      th(v-if="showCol('sections')")
        | Print sections
      th(v-if="showCol('web_categories')")
        | Web category
      th(v-if="showCol('words')")
        SortLink(v-model="sort" column="words" text="Words / Inches")
      th(v-if="showCol('media')")
        SortLink(v-model="sort" column="media_count" text="Attachments")
      th(v-if="showCol('exported')")
        SortLink(v-model="sort" column="exported" text="Web Export")
      th(v-if="showCol('squeue')")
        SortLink(v-model="sort" column="squeue_title" text="Status")
      th.actions(v-if="showCol('actions')")
        | Actions

  tbody
    StoryRow(
      v-for="story in stories"
      :story="story"
      :columns="columns"
      :key="story.id"
      v-on="$listeners"
    )
</template>

<script>
  import { sync } from 'vuex-pathify'
  import { mapStores, mapWritableState } from 'pinia'
  import { useCurrentUserStore } from '@/stores/current_user'
  import { useStoryBatchOptionsStore } from '@/stores/story_batch_options'
  import { useStorySearchStore } from '@/stores/story_search'
  import CheckBox from './check_box.vue'
  import SortLink from './sort_link.vue'
  import StoryRow from './story_row.vue'
  import { sortParamsForSearch } from '@/store/shared/sorting'

  const COLUMNS = [
    'color',
    'checkbox',
    'id',
    'pub_date',
    'name',
    'slug',
    'subsites',
    'sections',
    'web_categories',
    'words',
    'media',
    'exported',
    'squeue',
    'actions',
    'locker'
  ]
  const WATCHED_PROPERTIES = [...COLUMNS, 'updated_at']

  export { COLUMNS, WATCHED_PROPERTIES }

  export default {
    components: {
      CheckBox,
      SortLink,
      StoryRow
    },

    props: {
      columns: {
        type: Array,
        default: () => COLUMNS
      }
    },

    computed: {
      stories: sync('stories/stories'),
      ...mapStores(
        useCurrentUserStore,
        useStoryBatchOptionsStore,
        useStorySearchStore
      ),
      ...mapWritableState(useStorySearchStore, ['search']),

      checked: {
        get() {
          const { selectedStoryIds } = this.storyBatchOptionsStore

          return this.stories.every(
            story => selectedStoryIds.includes(story.id)
          );
        },

        set(val) {
          this.stories.forEach(story => {
            this.storyBatchOptionsStore.set(story.id, val)
          });
        }
      },

      sort: {
        get() {
          // Sometimes because of differnt sorting options for fulltext search, we can't use
          // the preferred sort params. So we have sortParamsForSearch to figure that out.
          const { sort_column, sort_direction } = sortParamsForSearch(this.search)

          return { column: sort_column, direction: sort_direction }
        },
        set(val) {
          this.search.sort_column = val.column;
          this.search.sort_direction = val.direction;

          this.$emit('sort', val);
        }
      }
    },

    methods: {
      showCol(column) {
        return this.columns.includes(column)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .content-list {
    th {
      font-weight: 700 !important;
    }

    td.actions>.btn-group {
      min-width: 45px;
    }
  }
</style>
